import React from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import NotificationManager from "../../common/notification/NotificationManager";
import { PASTE_CONFIGURATION_NOTIFICATION } from "../../utils/constants/notification";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { CoObjectItem, TgkAmountObjectSource, TgkTableObjectSource } from "../interfaces/CoObject";
import { SourceEnum } from "../../api/models";
import { getClipboardText } from "../../utils/helpers/Clipboard";
import { parseJsonToType } from "../../utils/helpers/JsonHelper";
import { isOnWordWeb } from "../../api/config/ExternalConfig";

interface PasteObjectProps {
  objectType: "TABLE" | "CHART" | "AMOUNT" | "AMOUNT_AIH";
  onPasteObject: (pastedObject: CoObjectItem) => void;
}

export const PasteObject: React.FunctionComponent<PasteObjectProps> = (props) => {
  if (isOnWordWeb()) return null;
  function handleUnsupported(objectType: string) {
    throw new Error(`Object type ${objectType} not supported`);
  }

  function handleTableAndChart(parsedObject: CoObjectItem) {
    let parsedSource = parsedObject.source as TgkTableObjectSource;
    parsedSource.objectSource = SourceEnum.FORM;
    parsedSource.inheritFormatImage = true;

    if (props.objectType === "CHART") {
      parsedObject.info = {
        ...parsedObject.info,
        objectType: "CHART",
      };
      parsedSource.elabResultType = "IMAGE_STRINGBASE64";
      parsedSource.type = "CHART";
    } else if (props.objectType === "TABLE") {
      parsedObject.info = {
        ...parsedObject.info,
        objectType: "TABLE",
      };
      parsedSource.elabResultType = "STRINGBASE64";
      parsedSource.type = "TABLE";
    }
    parsedObject.source = parsedSource;
  }

  function handleAmount(parsedObject: CoObjectItem) {
    let parsedSource = parsedObject.source as TgkAmountObjectSource;

    parsedObject.info = {
      ...parsedObject.info,
      objectType: "AMOUNT",
    };
    parsedSource.type = "AMOUNT";
    parsedSource.objectSource = SourceEnum.TAGETIK_FORM;
    parsedObject.source = parsedSource;
  }

  const pasteObjectFromClipboard = async () => {
    try {
      let clipboardText = await getClipboardText();
      let parsedObject = parseJsonToType<CoObjectItem>(clipboardText);

      if (!parsedObject.parameters) parsedObject.parameters = [];
      if (parsedObject.source && !parsedObject.source.dimensions) parsedObject.source.dimensions = [];

      switch (props.objectType) {
        case "CHART":
        case "TABLE":
          handleTableAndChart(parsedObject);
          break;
        case "AMOUNT":
          handleAmount(parsedObject);
          break;
        default:
          handleUnsupported(props.objectType);
      }
      props.onPasteObject(parsedObject);
    } catch (e) {
      console.error(e);
      NotificationManager.addNotification({
        key: PASTE_CONFIGURATION_NOTIFICATION,
        message: e.message || formatMessage("cof.access.manageconfigurations.message.pasteconfigurationerror"),
        title: "Error",
        type: "error",
        closable: true,
        removeOnClose: true,
        isTemporary: true,
      });
    }
  };

  return (
    <div
      className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
      style={{
        marginTop: "25px",
        marginBottom: "25px",
      }}
    >
      <div>
        {formatMessage("cof.newobject.pastefromform")}
        <PrimaryButton
          style={{ float: "right", minHeight: "20px", padding: "0px" }}
          text={formatMessage("cof.base.pastesettings")}
          onClick={pasteObjectFromClipboard}
        />
      </div>
    </div>
  );
};
